import { createIndex, getCropName, getCroppingDatesInYear, getStdFieldHistory, ICropping, sortDates } from "../../omnia"
import { CroppingRef } from "./editContext"

export interface CroppingHistory {
    start: Date,
    end: Date,
    cropping: ICropping,
    prev: CroppingHistory[]
    next: CroppingHistory[]
}

export function getHistory(target: ICropping): CroppingHistory[] {

    const field = target.Field
    if (!field) return []

    const targetId = target.CroppingId

    const cropping = field.Cropping.filter(c => c.CroppingId != targetId)

    const history = getStdFieldHistory(cropping, { fieldArea: field.CroppingArea, fieldName: field.Name }).map(n => ({
        node: n,
        cropping: n.cropping,
        ...getCroppingDatesInYear(n.cropping),
        prev: [] as CroppingHistory[],
        next: [] as CroppingHistory[],
    }))

    const index = createIndex(history, i => i.cropping.CroppingId)

    const getRelated = (r: ICropping[]) => (r || []).map(i => index[i.CroppingId]).filter(n => !!n)

    history.forEach(h => {
        h.prev = getRelated(h.node.prev)
        h.next = getRelated(h.node.next)
    })

    const nodes = history.sort((a, b) => sortDates(b.end, a.end))

    return nodes

}

export function getUpdatedPrevList(target: ICropping, prev: CroppingRef) {

    const current = prev ? prev.id : target.MainPreviousId

    const field = target.Field
    if (!field) return null

    target = {
        CroppingId: -1,
        ...target
    }

    const potential = getPotentialPrevious(target)

    const prevlist = potential.map(c => ({
        id: c.CroppingId,
        area: c.Area,
        descr: `${getCropName(c)} - ${c.Area} ha`
    }))

    prev = current
        ? prevlist.find(n => n.id == current)
        : null

    return {
        prevlist,
        prev
    }

}

function getPotentialPrevious(target: ICropping) {

    const field = target.Field
    const croppingId = target.CroppingId
    const start = target.SowingDate || target.StartDate

    let prev = getPrev(target.YearId)
    if (!prev.length) prev = getPrev(target.YearId - 1)

    return prev

    ///

    function getPrev(year: number) {

        return (field.Cropping || [])
            .filter(c => c.CroppingId != croppingId)
            .filter(c => c.EndDate <= start)
            .filter(c => c.YearId == year)
            .filter(c => !(c.Crop && c.Crop.Perennial))

    }

}

function getPotentialPrevious1(target: ICropping) {

    const field = target.Field
    const croppingId = target.CroppingId

    const cropping = (field.Cropping || []).filter(c => c.CroppingId != croppingId).concat([target])

    const history = getStdFieldHistory(cropping, { fieldArea: field.CroppingArea, fieldName: field.Name })
    if (!history) return null

    const node = history.find(n => n.cropping == target)
    if (!node) return null

    return node.prev

}
